import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { HrCreatePersonPayload } from 'api/actions/hr-create-person/hr-create-person-payload';
import { HrCreatePersonPathParameters } from 'api/actions/hr-create-person/hr-create-person-path-parameters';
import { HrCreatePersonResponse } from 'api/actions/hr-create-person/hr-create-person-response';

type HrCreatePersonQueryParameters = Record<string, any>;

/**
 * The path of the HrCreatePerson action.
 */
export const hrCreatePersonActionPath = new SweetPath<keyof HrCreatePersonPathParameters>('/api/hr/people', {
  path: '{param}',
});

/**
 * Creates a contextualized HrCreatePerson actions.
 */
export default function createHrCreatePersonAction(axios: AxiosInstance) {
  return function hrCreatePersonAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: HrCreatePersonQueryParameters;
    payload: HrCreatePersonPayload;
  }) {
    const path = hrCreatePersonActionPath.original;

    return axios.request<HrCreatePersonResponse, HrCreatePersonResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
